import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';

export const firebaseConfig = {
  apiKey: 'AIzaSyBXWIyBvP8I8Hdz1bQlpr4b8p9_pjh5T9c',
  authDomain: 'audio-at-play.firebaseapp.com',
  projectId: 'audio-at-play',
  storageBucket: 'audio-at-play.firebasestorage.app',
  messagingSenderId: '216882548061',
  appId: '1:216882548061:web:c18cdc499d5ba5485f6cb4',
  measurementId: 'G-KVN05P61S8',
};

export const app = initializeApp(firebaseConfig);

// Analytics is optional and only available in browser environments.
export const analyticsPromise =
  typeof window !== 'undefined'
    ? isAnalyticsSupported()
        .then((supported) => (supported ? getAnalytics(app) : null))
        .catch(() => null)
    : Promise.resolve(null);
